import { render, staticRenderFns } from "./OSelect.vue?vue&type=template&id=607cfa36&scoped=true&"
import script from "./OSelect.vue?vue&type=script&lang=js&"
export * from "./OSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607cfa36",
  null
  
)

export default component.exports